export const ROLES = [
  {title: 'Champion', type: 'champion', color: '#a83e7a'},
  {title: 'Stakeholder', type: 'stakeholder', color: '#3b73a3'},
  {title: 'Decision Maker', type: 'decision_maker', color: '#4d8032'},
  {title: 'Economic Buyer', type: 'economic_buyer', color: '#9e7131'},
  {title: 'Technical Buyer', type: 'technical_buyer', color: '#7a52cc'},
  {title: 'Influencer', type: 'influencer', color: '#9b4aad'},
  {title: 'Blocker', type: 'blocker', color: '#d15b39'}
]